import { useSetModal } from "@/shared/atoms/useModal";
import { useSetCart } from "@/shared/hooks/useCartHook";
import useDiscountCodeHook from "@/shared/hooks/useDiscountCodeHook";

const useKioskReset = () => {
  const setCart = useSetCart();
  const setModal = useSetModal();
  const { setDiscountCode } = useDiscountCodeHook();
  return () => {
    setDiscountCode({ code: "", isApplied: false });
    setCart([]);
    setModal("");
  };
};

export default useKioskReset;
